import React, { useState, useEffect } from "react";
import { Form, Input, Modal, Typography, Flex, notification } from "antd";
import { Link } from "react-router-dom";
import PhoneInput from "antd-phone-input";
import { colors } from "helpers/constants";
import { Button } from "components/Common/Button";
import usePrimaryColor from "helpers/hooks/usePrimaryColor";
import "./styles.scss";

const OTP = ({
	phoneNumber,
	user,
	sendOtpToPhoneNumberTrigger,
	token,
	changePhoneNumberButtonProps: { onClick: changePhoneNumberSubmit, ...changePhoneNumberButtonProps },
	continueButtonProps: { onClick: onContinue, ...continueButtonProps },
	resendOtpProps,
	hideChangeNumber,
}) => {
	const [otp, setOtp] = useState("");
	const [form] = Form.useForm();
	const primaryColor = usePrimaryColor();
	const inputRef = React.useRef();
	const ref = React.useRef();

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [values, setValues] = useState({});
	const handleOtpChange = (e) => {
		setOtp(e?.target?.value);
	};
	useEffect(() => {
		if (ref.current) {
			const inputs = ref.current?.getElementsByTagName?.("input");
			if (inputs) {
				Array.from(inputs).forEach((input) => {
					input.placeholder = "1";
				});
			}
		}
		if (inputRef.current) {
			inputRef.current.focus({
				cursor: "start",
			});
		}
	}, [inputRef, ref]);
	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleOk = async () => {
		try {
			const phoneNumber = form.getFieldValue("newPhoneNumber");
			const number = `+${phoneNumber?.countryCode}${phoneNumber?.areaCode}${phoneNumber?.phoneNumber}`;
			await sendOtpToPhoneNumberTrigger({
				new_phone_number: number,
				token,
			}).unwrap();
			setIsModalVisible(false);
		} catch (error) {
			notification.error({
				message: error?.data?.message || "Error sending OTP. Please try again later.",
			});
		}
	};

	const handleResendOtp = async () => {
		try {
			await sendOtpToPhoneNumberTrigger({
				new_phone_number: phoneNumber,
				token,
			}).unwrap();
			notification.success({
				message: "OTP sent successfully!",
			});
		} catch (error) {
			notification.error({
				message: error?.data?.message || "Error sending OTP. Please try again later.",
			});
		}
	};

	return (
		<Form
			form={form}
			onFinish={() => onContinue(values)}
			initialValues={{ newPhoneNumber: phoneNumber }}
			className="verify-phone-number"
			layout="vertical"
			onValuesChange={(v) => setValues((vals) => ({ ...vals, ...v }))}
		>
			<Typography.Paragraph className="form-label" style={{ color: colors.text, fontSize: 15, fontWeight: 500 }}>
				Enter your OTP sent to your Phone
			</Typography.Paragraph>
			<Typography.Paragraph className="form-label" style={{ color: colors.text, fontSize: 15, fontWeight: 500 }}>
				{phoneNumber}
			</Typography.Paragraph>
			<Flex ref={ref} justify="center">
				<Form.Item name="otp" rules={[{ required: true, message: "Please enter a valid 6-digit OTP" }]}>
					<Input.OTP ref={inputRef} value={otp} onChange={handleOtpChange} maxLength={6} />
				</Form.Item>
			</Flex>
			<Typography.Paragraph className="form-label" size={12}>
				Your one time password will expire in 10 minutes.
			</Typography.Paragraph>
			{!hideChangeNumber && (
				<Typography.Paragraph style={{ color: primaryColor }}>
					<Link
						to="#"
						style={{ color: primaryColor }}
						onClick={() => setIsModalVisible(true)}
						className="sb-login-form__forgot-password"
					>
						Change the phone number
					</Link>{" "}
					|{" "}
					<span
						type="link"
						onClick={handleResendOtp}
						style={{
							padding: 0,
							color: primaryColor,
							fontSize: 14,
							cursor: "pointer",
							textDecoration: "underline",
						}}
					>
						Resend OTP
					</span>
				</Typography.Paragraph>
			)}

			<Modal
				title="Change Phone Number"
				footer={
					<div className="sb-confirm-form__actions">
						<Button
							style={{ height: 40, textTransform: "none", fontSize: 14, fontWeight: 700 }}
							onClick={() => setIsModalVisible(false)}
							className="sb-release-schedule-form__form__button primary-outlined"
						>
							Cancel
						</Button>
						<Button
							htmlType="button"
							style={{ height: 40, textTransform: "none", fontSize: 14, fontWeight: 700 }}
							className="sb-release-schedule-form__form__button primary-filled"
							type="primary"
							{...changePhoneNumberButtonProps}
							onClick={handleOk}
						>
							Submit
						</Button>
					</div>
				}
				open={isModalVisible}
				onCancel={handleCancel}
				destroyOnClose
				maskClosable={false}
				className="change-phone-number-modal"
			>
				<Form.Item
					label="New Phone Number"
					name="newPhoneNumber"
					rules={[{ required: true, message: "Please enter your new phone number" }]}
				>
					<PhoneInput distinct />
				</Form.Item>
			</Modal>
			<Flex gap={16} style={{ marginTop: 48 }} vertical className="sb-login-phone-verify-form__buttons">
				<Button
					size="small"
					htmlType="button"
					type={"button"}
					className="primary-outlined verify-btn"
					data-id="btnSkip"
					style={{ width: "100%", maxWidth: "unset", fontSize: 14, fontWeight: 700 }}
					{...resendOtpProps}
				>
					{resendOtpProps?.children || (user.id ? "Resend OTP" : "Back to Login")}
				</Button>
				<Button
					size="small"
					className="primary-filled--branding-primary-color verify-btn"
					type="primary"
					style={{ backgroundColor: primaryColor, width: "100%", maxWidth: "unset" }}
					{...continueButtonProps}
					data-id="btnContinue"
					htmlType="submit"
				>
					<Typography.Text style={{ color: "#FFF", fontSize: 14, fontWeight: 700 }}>Continue</Typography.Text>
				</Button>
			</Flex>
		</Form>
	);
};

export default OTP;

